import {
    IssuesDto,
    IssueSingleDto,
    CreateIssueCommentDto,
    IssueItemDto,
    ClassifierResponseDto,
    CreateIssueResponseDto,
    CreateIssueRequestDto
} from '../types';
import { IIssuesApi } from './Interface/IIssuesApi';
import { ApiService } from '@/services/ApiService';

export default class IssuesApi extends ApiService implements IIssuesApi {
    async getIssues(): Promise<IssuesDto | undefined> {
        return await this.httpGet<IssuesDto | undefined>(`/api/fort/profiles/me/issues`);
    }

    async getSingleIssue(issueId: number): Promise<IssueSingleDto | undefined> {
        return await this.httpGet<IssueSingleDto | undefined>(`/api/fort/profiles/me/issues/${issueId}`);
    }

    async createIssueComment(issueId: number, issueComment: CreateIssueCommentDto): Promise<IssueItemDto | undefined> {
        return await this.httpPost<IssueItemDto>(`/api/fort/profiles/me/issues/${issueId}/comments`, issueComment);
    }

    async getIssueCategories(): Promise<ClassifierResponseDto | undefined> {
        return await this.httpGet<ClassifierResponseDto | undefined>(`/api/v1.0/classifier/issue/issueCategory`);
    }

    async getIssueTypes(): Promise<ClassifierResponseDto | undefined> {
        return await this.httpGet<ClassifierResponseDto | undefined>(`/api/v1.0/classifier/issue/issueType`);
    }

    async createMyIssue(issue: CreateIssueRequestDto): Promise<CreateIssueResponseDto | undefined> {
        return await this.httpPost<CreateIssueResponseDto | undefined>(`/api/fort/profiles/me/issues`, issue);
    }

    async getClassifiers(classifiers: string): Promise<ClassifierResponseDto[] | undefined> {
        return await this.httpGet<ClassifierResponseDto[] | undefined>(`/api/v1.0/classifier/multiple/${classifiers}`);
    }

    async createIssue(issue: CreateIssueRequestDto): Promise<CreateIssueResponseDto | undefined> {
        return await this.httpPost<CreateIssueResponseDto | undefined>(`/api/v1.0/issues`, issue);
    }

    async getIssueAttachment(issuesId: number, attachmentId: string): Promise<Response | undefined> {
        return await fetch(`/api/v1.0/issues/${issuesId}/attachments/${attachmentId}`);
    }
}
